module.exports = __webpack_public_path__ + "static/background-69cc68ddb8f82bded25d6d8adc320e6c.jpg";